import { TypeProfil } from "@modules/plaintes/plaintes.model.ts";

export interface ProfileDTO {
  data: ProfilForm;
  file: string;
}

export interface PartenerModel {
  organizationName: string;
  acronym: string;
  legalStatuses: string[];
  otherLegalStatus: string;
  // interventionZone: string; // Champ désactivé (ne pas utiliser)
  concernedBranches: string[];
  otherConcernedBranches: string;
  physicalOrPostalAddress: string;
  mainPhoneNumber: string;
  generalEmailAddress: string;
  website: string;
  partnershipTypes: string[];
  otherPartnershipType: string;
  interventionDomains: string;
  rolesAndResponsibilities: string;
  collaborationStartDate?: any;
  collaborationEndDate?: any
  referenceDocuments: string[];
  otherReferenceDocument: string;
  reportingChannels: string[];
  otherReportingChannel: string;
  referenceDocumentFileName?: string;
  referenceDocumentFilePath?: string;
  referenceDocumentContentType?: string;
}
export interface ProfilDTO {
  id: string;
  name: string;
  description: string;
  external: boolean;
  admin: boolean;
  permissions: PermissionDTO[];
  profilId: {
    value: string;
  };
  accesses: {
    id: number;
    description: string;
    name: string;
    internalAgent: boolean;
  }[];
  type: TypeProfil;
  partner?: PartnerDTO | null;
  externalPartner?: PartnerDTO | null;
}

export interface ProfilForm {
  name: string;
  description: string;
  permissions: string[];
  accesses: number[];
  partner?: PartenerModel | null;
  uploadedFile?: {
    fileName: string;
    contentType: string;
    content: File;
  } | null;
}

export interface GroupedAccess {
  internalAgent: boolean;
  options: {
    id: number;
    description: string;
  }[];
}
export interface GroupedAccessAdmin {
  adminAgent: boolean;
  options: {
    id: number;
    description: string;
  }[];
}

export interface PermissionDTO {
  id?: string;
  permissionId: string;
  name: string;
  description: string;
  profiles: any;
}

export interface Profil {
  name: string;
  description: string;
  permissions: string[];
  accesses: number[];
  partner?: PartnerDTO | null;
  uploadedFile?: File;
}

export interface Permission {
  id: string;
  name: string;
  description: string;
  internalAgent?: boolean;
  adminAgent?: boolean;
  admin?: boolean
}

export interface ProfilPutDTO {
  profileId: string;
  name: string;
  description: string;
  permissions: string[];
  accesses: number[];
  partner?: PartnerDTO | null;
  uploadedFile?: {
    fileName: string;
    contentType: string;
    content: File;
  } | null;
}


export interface EditProfilFormData {
  profileId: string;
  data: ProfilForm;
  file: File | null;
}


export interface ProfilFormData {
  data: ProfilForm;
  file: File | null;
}
export interface ProfilTransferDTO {
  id: string;
  name: string;
  description: string;
  type: TypeProfil
}

export enum LegalStatus {
  ONG = "ONG",
  INTERNATIONAL_ORGANIZATION = "INTERNATIONAL_ORGANIZATION",
  PUBLIC_INSTITUTION = "PUBLIC_INSTITUTION",
  OTHER = "OTHER",
}
export const LegalStatusList = [
  { name: "ONG", code: LegalStatus.ONG },
  {
    name: "Organisation internationale",
    code: LegalStatus.INTERNATIONAL_ORGANIZATION,
  },
  { name: "Institution publique", code: LegalStatus.PUBLIC_INSTITUTION },
  { name: "Autre", code: LegalStatus.OTHER },
];

export enum ConcernedBranches {
  VBG = "VBG",
  PEAS = "PEAS",
  PE = "PE",
  PSRC="PSRC",
  MOCIP = "MOCIP",
  OTHER = "OTHER",
}
export const ConcernedBranchesList = [
  { name: "VBG", code: ConcernedBranches.VBG },
  { name: "PEAS", code: ConcernedBranches.PEAS },
  { name: "PE", code: ConcernedBranches.PE },
  { name: "PSRC", code: ConcernedBranches.PSRC },
  { name: "MOCIP", code: ConcernedBranches.MOCIP },
  { name: "OTHER", code: ConcernedBranches.OTHER },
];

export enum PartnershipType {
  TECHNICAL = "TECHNICAL",
  FINANCIAL = "FINANCIAL",
  OPERATIONAL = "OPERATIONAL",
  INSTITUTIONAL = "INSTITUTIONAL",
  OTHER = "OTHER",
}

export const PartnershipTypeList = [
  { name: "Technique", code: PartnershipType.TECHNICAL },
  { name: "Financier", code: PartnershipType.FINANCIAL },
  { name: "Opérationnel", code: PartnershipType.OPERATIONAL },
  { name: "Institutionnel", code: PartnershipType.INSTITUTIONAL },
  { name: "Autre ", code: PartnershipType.OTHER },
];

export enum InformationChannel {
  PLATFORM = "PLATFORM",
  EMAIL = "EMAIL",
  OTHER = "OTHER",
}

export const InformationChannelList = [
  { name: "Plateforme", code: InformationChannel.PLATFORM },
  { name: "E-mail", code: InformationChannel.EMAIL },
  { name: "Autre ", code: InformationChannel.OTHER },
];

export enum ReferenceDocuments {
  MOU = "MOU",
  CONVENTION = "CONVENTION",
  PROTOCOL_OF_AGREEMENT = "PROTOCOL_OF_AGREEMENT",
  OTHER = "OTHER",
}

export const ReferenceDocumentsList = [
  { name: "MOU", code: ReferenceDocuments.MOU },
  { name: "Convention", code: ReferenceDocuments.CONVENTION },
  {name: "Protocole d'accord", code: ReferenceDocuments.PROTOCOL_OF_AGREEMENT},
  { name: "Autre ", code: ReferenceDocuments.OTHER },
];

export interface PartnerDTO {
  id?: number;
  profil: ProfilDTO;
  organizationName: string;
  acronym: string;
  legalStatuses: string[];
  otherLegalStatus: string;
  // interventionZone: string; // Champ désactivé (ne pas utiliser)
  concernedBranches: string[];
  otherConcernedBranches: string;
  physicalOrPostalAddress: string;
  mainPhoneNumber: string;
  generalEmailAddress: string;
  website: string;
  partnershipTypes: string[];
  otherPartnershipType: string;
  interventionDomains: string;
  rolesAndResponsibilities: string;
  collaborationStartDate: string;
  collaborationEndDate: string;
  referenceDocuments: string[];
  otherReferenceDocument: string;
  reportingChannels: string[];
  otherReportingChannel: string;
}

export interface UploadedFileDTO {
  fileName: string;
  contentType: string;
  content: string;
}